import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

class CustomerImpactingRadioGroup extends React.Component {

    constructor(props) {
        super(props);

        this.handleCustomerImpactingRadioGroupChange = this
            .handleCustomerImpactingRadioGroupChange
            .bind(this);

    }

    handleCustomerImpactingRadioGroupChange(e, value) {
        const { workOrderActions, orderId, orderCloseDetails } = this.props;
        let comment = null;
        const existingTicket = orderCloseDetails
            .getIn(['closeOrderRequest', 'ticketRequests'])
            .find((item) => {

                return item.get('workType') === 'Maintenance';

            });

        if (existingTicket) {
            comment = existingTicket.get('comment');
        }

        if (value === 'yes') {
            workOrderActions.ticketRequestAdd({
                workType: 'Maintenance',
                customerImpacting: true,
                comment: comment
            }, orderId);
        }

        if (value === 'no') {
            workOrderActions.ticketRequestAdd({
                workType: 'Maintenance',
                customerImpacting: false,
                comment: comment
            }, orderId);
        }

    }

    render() {
        const { orderCloseDetails, disabled } = this.props;

        let existingTicket = false,
            defaultCustomerImpacting = 'no',

            stepTwoStyle = {
                display: 'none'
            };

        if (orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests']) && orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests']).find) {

            existingTicket = orderCloseDetails
                .getIn(['closeOrderRequest', 'ticketRequests'])
                .find((item) => {

                    return item.get('workType') === 'Maintenance';

                });

            if (existingTicket) {
                stepTwoStyle = {};
            } else {
                stepTwoStyle = {
                    display: 'none'
                };
            }

            if (existingTicket && existingTicket.get('customerImpacting')) {
                defaultCustomerImpacting = 'yes';
            } else {
                defaultCustomerImpacting = 'no';
            }

        }

        return (

            <div style={stepTwoStyle}>

                <label>
                    Customer Impacting?</label>
                <RadioButtonGroup
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                    onChange={this.handleCustomerImpactingRadioGroupChange}
                    name="customerImpacting"
                    valueSelected={defaultCustomerImpacting}>
                    <RadioButton
                        disabled={existingTicket ? true : disabled}
                        value="no"
                        label="No"
                        style={{
                            display: 'inline-block'
                        }} />
                    <RadioButton
                        disabled={disabled}
                        value="yes"
                        label="Yes"
                        style={{
                            display: 'inline-block'
                        }} />

                </RadioButtonGroup>
            </div>

        );

    }
}

CustomerImpactingRadioGroup.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool
};

export default CustomerImpactingRadioGroup;


// WEBPACK FOOTER //
// ./src/components/ticket/CustomerImpactingRadioGroup.js